export default __webpack_public_path__ + "static/media/card-formation-bg.d499c227.png";